/**
 * Global toast notification utility — XSS-safe, no innerHTML with dynamic content.
 * Creates a shared #global-toast-stack fixed container on first call.
 *
 * @param {'success'|'error'|'warning'|'info'} type
 * @param {string} message
 * @param {{ duration?: number }} options
 */

let _stack = null;

function ensureStack() {
  if (_stack && document.body.contains(_stack)) return _stack;
  const existing = document.getElementById('global-toast-stack');
  if (existing) { _stack = existing; return _stack; }

  const stack = document.createElement('div');
  stack.id = 'global-toast-stack';
  document.body.appendChild(stack);
  _stack = stack;
  return _stack;
}

export function toast(type, message, { duration = 4000 } = {}) {
  const stack = ensureStack();

  const item = document.createElement('div');
  item.className = `toast-item toast-item--${type}`;
  item.setAttribute('role', 'status');
  item.setAttribute('aria-live', 'polite');

  const msgSpan = document.createElement('span');
  msgSpan.className = 'toast-item__msg';
  msgSpan.textContent = String(message || '');
  item.appendChild(msgSpan);

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'toast-item__close';
  closeBtn.setAttribute('aria-label', 'Dismiss');
  closeBtn.textContent = '\u00d7'; // ×
  item.appendChild(closeBtn);

  const dismiss = () => {
    item.classList.add('toast-item--out');
    setTimeout(() => item.remove(), 300);
  };

  closeBtn.onclick = dismiss;
  stack.appendChild(item);

  requestAnimationFrame(() => item.classList.add('toast-item--in'));

  if (duration > 0) {
    setTimeout(dismiss, duration);
  }
}
